import { useState } from 'react';
import { FormControl, Stack, FormLabel, Box } from '@chakra-ui/react';
import { Field } from 'formik';
import { usePartnerForm } from '../../hooks/usePartnerForm';
import NameField from '@/components/forms/new/formikFormFields/NameField';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import { FORM_FIELD_PATHS } from '../../constants';
import {
    stackSpacing,
    formLabelStyling,
    stackStyling,
} from 'components/forms/new/formStyles';

const PartnerName = ({ darkMode, errors, isAddMode }) => {
    const [isHovered, setIsHovered] = useState(false);
    const { formData, updateFormData } = usePartnerForm();

    const handleChange = (e) => {
        updateFormData(FORM_FIELD_PATHS.NAME, e.target.value);
        // In add mode, also update entity name
        if (isAddMode) {
            updateFormData(FORM_FIELD_PATHS.ENTITY_NAME, e.target.value);
        }
    };

    const hasError = !!errors?.name;
    return (
        <FormControl
            sx={{ margin: '0 !important' }}
            isInvalid={hasError}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack direction="row" spacing={stackSpacing} sx={stackStyling()}>
                <FormLabel sx={formLabelStyling(darkMode)}>
                    {isAddMode ? 'Partner Name' : 'Friendly Partner Name'}{' '}
                    <span style={{ color: '#e53e3e' }}>*</span>
                </FormLabel>
                <Box flex={1} maxWidth="400px">
                    <Field
                        component={NameField}
                        id={FORM_FIELD_PATHS.NAME}
                        name={FORM_FIELD_PATHS.NAME}
                        value={formData?.[FORM_FIELD_PATHS.NAME] || ''}
                        onChange={handleChange}
                        placeholder={
                            isAddMode ? 'Partner Name' : 'Friendly Partner Name'
                        }
                        width="100%"
                        darkMode={darkMode}
                        isInvalid={hasError}
                        validate={() => {
                            if (!formData?.[FORM_FIELD_PATHS.NAME]) {
                                return 'Partner name is required';
                            }
                        }}
                    />
                </Box>
                {isHovered && (
                    <FieldToolTip
                        label={
                            isAddMode
                                ? 'Enter the partner name'
                                : 'Enter a friendly display name for the partner'
                        }
                        ariaLabel="partner-name-tip"
                        left="25px"
                        top="25px"
                    />
                )}
            </Stack>
        </FormControl>
    );
};

export default PartnerName;
